export default __webpack_public_path__ + "static/media/partner_logo_goodtech.d55faea1.svg";